import React from 'react';

interface CheckmarkCircleIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const CheckmarkCircleIcon: React.FC<CheckmarkCircleIconProps> = ({
  size = 20,
  color = 'var(--dr-link-blue)',
  className
}) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      style={{ color }}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
};

export default CheckmarkCircleIcon;
